import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import queryString from "query-string";
import { AiOutlineMenu, AiOutlineSearch } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";
import { push as Menu } from "react-burger-menu";
import { Modal } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import ChangeOfUnit from "components/layout/ChangeOfUnit";
import Enderecos from "components/MI/endereco/modal";
import ModalMultiplos from "../../layout/multiplos";
import NavbarLink from "../NavbarLink";
import UserMenuIcon from "components/MI/UserMenuIcon";
import { pages, socials } from "../Navbar/pagesMenu";
import { resetMultiplosState } from "store/actions/multiplos-actions";

import {
  Address,
  BoxAddress,
  BoxNameAddress,
  BoxTwoBars,
  CompanyContainer,
  Content,
  ContentLeft,
  ContentMenuBurger,
  ContentSearch,
  DivOuterContainer,
  IconMenu,
  IconsContainer,
  InputSearch,
  Logo,
  MenuItemContainer,
  Name,
  NavLogo,
  NavbarComponent,
  SocialContainer,
  SocialIcon,
  TwoBars,
} from "./styles";

type DrawerProps = {
  selected?: string;
  openSubMenu?: boolean;
  children: JSX.Element | JSX.Element[];
};

const Drawer = ({
  selected,
  openSubMenu,
  children,
}: DrawerProps): JSX.Element => {
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState<boolean>();
  const [addressModal, setAddressModal] = useState<boolean>();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [openElement, setOpenElement] = useState<boolean>(false);
  const selectedUnit = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const ref = useRef<any>();

  const addressLine = localStorage.getItem(
    "@UltragazEmpresarial:customerAddressLine"
  );

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
    dispatch(resetMultiplosState());
  }, [dispatch, setShowModal]);

  const setCloseMenu = (): void => {
    setIsDrawerOpen(false);
  };

  const handleIsOpen = (): void => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const address = useMemo(() => {
    if (selectedUnit?.address) {
      const unit =
        selectedUnit.address.find((unit) => unit.addressType === "SHIP_TO") ||
        {};
      return `${unit?.address || unit?.fullAddress}, ${unit?.number || "S/N"}${
        unit?.complement ? `, ${unit?.complement}` : ""
      }${unit.neighborhoods ? `, ${unit?.neighborhoods}` : ""}${
        unit?.city ? `, ${unit?.city}` : ""
      }${unit?.stateCode ? `-${unit?.stateCode}` : ""}`;
    }

    return "";
  }, [selectedUnit]);

  const onEnterSearch = (): void => {
    history?.push(`/pesquisa/?search=${search}`);
  };

  const searchUrl = useMemo(() => {
    return queryString.parse(location.search)?.search;
  }, [location]);

  useEffect(() => {
    document?.addEventListener("click", handleOutsideClick);
  }, []);

  const handleOutsideClick = (event): void => {
    if (ref && !ref?.current?.contains(event.target)) {
      setOpenElement(false);
    } else {
      setOpenElement(true);
    }
  };

  return (
    <>
      <Menu
        isOpen={isDrawerOpen}
        onOpen={handleIsOpen}
        onClose={handleIsOpen}
        pageWrapId="page-wrap"
        outerContainerId="outer-container"
        styles={styles}
        width="250px"
        customCrossIcon={
          <ContentMenuBurger>
            <IoMdClose />
          </ContentMenuBurger>
        }
      >
        <Content>
          <NavLogo>
            <Logo src="/static/ultragaz-logo-white.svg" alt="Ultragaz logo" />
          </NavLogo>

          <CompanyContainer>
            <ChangeOfUnit />
          </CompanyContainer>

          <MenuItemContainer>
            <Scrollbars style={{ height: "100%" }}>
              {pages(selectedUnit).map((page) => {
                const isSelected = page.slug.includes(selected);
                const Icon = page.icon;

                return (
                  <NavbarLink
                    key={page?.key}
                    page={page}
                    isSelected={isSelected}
                    selected={selected}
                    Icon={Icon}
                    openSub={openSubMenu}
                    setCloseMenu={setCloseMenu}
                  />
                );
              })}
            </Scrollbars>
          </MenuItemContainer>

          <SocialContainer>
            {socials?.map((social) => (
              <SocialIcon
                key={social?.href}
                href={social?.href}
                target="_blank"
                aria-label={social?.alt}
                rel="external"
              >
                <img src={social?.img} alt={social?.alt} />
              </SocialIcon>
            ))}
          </SocialContainer>
        </Content>
      </Menu>
      <DivOuterContainer id="outer-container">
        <main id="page-wrap">
          <NavbarComponent>
            <ContentLeft>
              <IconMenu>
                <AiOutlineMenu />
              </IconMenu>
              <BoxTwoBars openElement={openElement}>
                <TwoBars>//</TwoBars>
                <BoxNameAddress>
                  <Name>{selectedUnit?.condominiumName || addressLine}</Name>
                  <BoxAddress>
                    <Address>{address}</Address>
                  </BoxAddress>
                </BoxNameAddress>
              </BoxTwoBars>
            </ContentLeft>
            <IconsContainer>
              <ContentSearch ref={ref} openElement={openElement}>
                <AiOutlineSearch />
                <InputSearch
                  placeholder="Pesquisar"
                  value={search ?? searchUrl}
                  onChange={(e) => setSearch(e?.currentTarget?.value)}
                  onKeyUpCapture={(e) => e?.key === "Enter" && onEnterSearch()}
                  openElement={openElement}
                />
              </ContentSearch>
              <UserMenuIcon />
            </IconsContainer>
            <Modal
              show={showModal}
              onHide={() => handleCloseModal()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              centered
              animation={false}
            >
              <ModalMultiplos close={() => handleCloseModal()} />
            </Modal>
            <Modal
              show={addressModal}
              size="lg"
              onHide={() => setAddressModal(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              centered
              animation={false}
            >
              <Enderecos close={() => setAddressModal(false)} />
            </Modal>
          </NavbarComponent>
          <div style={{ width: "100%", height: 80 }} />
          {children}
        </main>
      </DivOuterContainer>
    </>
  );
};

const styles = {
  bmBurgerButton: {
    position: "fixed",
    width: 50,
    height: 50,
    left: 7,
    top: 7,
  },
  bmBurgerBars: {
    background: "transparent",
    outline: "none",
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "24px",
    width: "24px",
    left: "20px",
    top: "25px",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
  },
  bmMorphShape: {
    // fill: "#074F8C"
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
  },
};

export default Drawer;
